import { useRootStore } from 'service/useRootStore'

import { BookingsParams } from '../types/Booking'
import { BookingHistoryType } from '../types/BookingHistory'

export const useBookingApi = () => {
  const { API } = useRootStore()

  return {
    getBookings: (params: BookingsParams) => {
      return API.bookings.browse(params)
    },
    getBookingById: (id: string) => {
      return API.bookings.getByID(id)
    },
    getLatestEventOfType: async (type: BookingHistoryType, id: string) => {
      const history = await API.bookings.getHistoryByID(id, { type })
      const latestEvent = history.items[0]

      if (latestEvent) {
        return latestEvent
      }

      throw new Error(`Failed to load latest event of type: ${type} for booking: ${id}`)
    },
    authorize: (id: string, comment: string) => {
      return API.bookings.authorize(id, comment)
    },
    reject: (id: string, comment: string) => {
      return API.bookings.reject(id, comment)
    },
    getBookingHistory: (id: string) => {
      return API.bookings.getHistoryByID(id)
    },

    getShipperLENames: () => {
      return API.bookings.getShipperLENames()
    },
  }
}
